import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  Alert,
  Badge,
  Button,
  Card,
  Checkbox,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Pagination,
  Radio,
  Spinner,
  Table,
  Tabs,
} from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN, CATEGORIES, QUERIES, USERS } from "../../config/apiConfig";
import { formatToReal } from "../../utils/utils";
import { IoMdSearch } from "react-icons/io";
import AutoCompleteInput from "../inputs/Autocomplete";
import EmptyTable from "./EmptyTable";
import {
  MdEdit,
  MdLocalPrintshop,
  MdOutlineAttachMoney,
  MdOutlineDisplaySettings,
  MdOutlinePageview,
  MdWarningAmber,
} from "react-icons/md";
import { BsFillBarChartFill } from "react-icons/bs";
import DrawerLoading from "../DrawerLoading";
import { IoCloudDownload } from "react-icons/io5";
import axiosInstance from "../../config/axiosInstance";
import { useApplication } from "../../contexts/ApplicationContext";
import { Tooltip } from "react-tooltip";
import { CodeBlock, CopyBlock, dracula } from "react-code-blocks";
import { useReactToPrint } from "react-to-print";
import { LuFilter, LuFilterX } from "react-icons/lu";
import ModalEditPrice from "../modals/ModalEditPrice";
import SelectedQueryReview from "../common/query/SelectedQueryReview";
import TableLoading from "../TableLoading";

const AdminHistoryTable = ({ isActive = true }) => {
  const queryClient = useQueryClient();
  const { userPermission } = useApplication();
  const [activeTab, setActiveTab] = useState(1);
  const [activeTabModal, setActiveTabModal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPriceSum, setTotalPriceSum] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const onPageChange = (page) => setCurrentPage(page);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [selectedQueries, setSelectedQueries] = useState([]);
  const [listCategoryQueries, setListCategoryQueries] = useState([]);
  const [openModalViewDetails, setOpenModalViewDetails] = useState(false);
  const reportRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef: reportRef });
  const [openModal, setOpenModal] = useState(false);
  const [dataQuery, setDataQuery] = useState(null);
  const [selectedQueryReview, setSelectedQueryReview] = useState(null);
  const printRef = useRef();
  const reactToPrintFnQuery = useReactToPrint({ contentRef: printRef });
  const [selectedCustomer, setSelectedCustomer] = useState({
    label: "Todos os clientes",
    value: 0,
  });

  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedIsModular, setSelectedModular] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [showFilters, setShowFilters] = useState(true);
  const [renderFilters, setRenderFilters] = useState(false);
  const [editPriceModalOpen, setEditPriceModalOpen] = useState(false);
  const [queryToEdit, setQueryToEdit] = useState(null);
  const [newPrice, setNewPrice] = useState("");

  useEffect(() => {
    if (showFilters) {
      setRenderFilters(true); // mostra o conteúdo imediatamente
    } else {
      // espera a animação terminar antes de esconder
      const timeout = setTimeout(() => setRenderFilters(false), 500); // mesmo tempo da transition
      return () => clearTimeout(timeout);
    }
  }, [showFilters]);

  const {
    isLoading: isLoadingQueryPermissions,
    error: errorQueryPermissions,
    data: userQueryPermissions,
  } = useQuery(
    ["userQueryPermissions"],
    async () => {
      const { data: items } = await axios.get(
        `${USERS.GET_USER_QUERY_PERMISSIONS}`
      );

      return items?.data?.map((query) => query.id);
    },
    { enabled: isActive }
  );

  const {
    isLoading: isLoadingCustomers,
    error: errorListCustomers,
    data: listCustomers,
  } = useQuery(
    ["listCustomers"],
    async () => {
      try {
        const { data } = await axios.get(
          `${ADMIN.GET_CUSTOMERS}?itemsPerPage=-1`
        );

        if (!data?.data?.data) {
          throw new Error("Erro ao buscar clientes");
        }

        let customers = data.data.data.map((customer) => ({
          label:
            customer.typeCustomer === "CPF"
              ? customer.name
              : customer.socialReason,
          value: customer.id,
          vcm: customer.vcm,
          typePayment: customer.typePayment,
          credit: customer.credit,
        }));

        customers = [{ label: "Todos os clientes", value: 0 }, ...customers];

        return customers;
      } catch (error) {
        throw new Error(`Erro ao buscar clientes: ${error.message}`);
      }
    },
    { enabled: isActive }
  );

  const {
    isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(["categories", currentPage], async () => {
    const { data } = await axios.get(`${CATEGORIES.GET_ALL}`);

    return data.data.data;
  });

  const {
    isLoading: isLoadingReportQueries,
    error: errorListReportQueries,
    data: listReportQueries,
  } = useQuery(
    [
      "listReportQueries",
      selectedCustomer,
      startDate,
      endDate,
      currentPage,
      selectedQueries,
      selectedStatuses,
      nameParam,
      selectedIsModular,
    ],
    async () => {
      const { data } = await axios.get(
        `${ADMIN.GET_COMPANY_QUERIES_HISTORY}/${selectedCustomer?.value}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&status=${selectedStatuses}&queries=${selectedQueries}&search=${nameParam}&isModular=${selectedIsModular}`
      );

      setTotalPages(data.data.totalPages);
      setTotalPriceSum(data.data.totalPriceSum);
      setTotalCount(data.data.totalCount);

      return data.data.data;
    },
    {
      enabled: activeTab === 0 && isActive,
    }
  );

  const {
    isLoading: isLoadingReportSimplifiedQueries,
    error: errorListReportSimplifiedQueries,
    data: listReportSimplifiedQueries,
  } = useQuery(
    [
      "listReportSimplifiedQueries",
      selectedCustomer,
      startDate,
      endDate,
      currentPage,
      selectedQueries,
      selectedStatuses,
      selectedIsModular,
    ],
    async () => {
      const { data } = await axios.get(
        `${ADMIN.GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED}/${selectedCustomer?.value}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&status=${selectedStatuses}&queries=${selectedQueries}&isModular=${selectedIsModular}`
      );

      setTotalPages(data.data.totalPages);
      setTotalPriceSum(data.data.totalSumPrice || 0);
      setTotalCount(data.data.totalSumCount);

      return data.data.data;
    },
    {
      enabled: activeTab === 1 && isActive,
    }
  );

  const {
    isLoading: isLoadingQueryDetails,
    error: errorQueryDetails,
    data: queryDetails,
  } = useQuery(
    ["queryDetails", selectedQuery],
    async () => {
      try {
        const { data } = await axios.get(
          `${ADMIN.GET_QUERY_DETAILS}/${selectedQuery?.id}`
        );

        return data.data;
      } catch (error) {
        throw new Error(`Erro ao buscar consulta: ${error.message}`);
      }
    },
    { enabled: isActive }
  );

  const handleCheckboxChange = (status, setState) => {
    setState((prev) =>
      prev.includes(status)
        ? prev.filter((item) => item !== status)
        : [...prev, status]
    );
  };

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab]);

  useEffect(() => {
    setListCategoryQueries(() =>
      categories?.map((category) => {
        return {
          ...category,
          Queries: category?.Queries?.filter((query) =>
            userQueryPermissions?.includes(query.id)
          ),
        };
      })
    );
  }, [userQueryPermissions, categories]);

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <Button
          size="xs"
          onClick={() => setShowFilters((prev) => !prev)}
          className="primary text-white transition-all duration-300"
        >
          <div className="flex items-center gap-2 transition-all duration-300">
            <span>{showFilters ? "Esconder filtros" : "Mostrar filtros"}</span>
            <span className={`transition-transform duration-300 `}>
              {!showFilters ? <LuFilter /> : <LuFilterX />}
            </span>
          </div>
        </Button>
      </div>
      <div className="flex flex-col gap-4">
        {showFilters && (
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden bg-white rounded-md shadow-sm border border-gray-200 p-4 relative`}
          >
            {renderFilters && (
              <div className="transition-opacity duration-500 min-w-[200px]">
                {(isLoadingCategories ||
                  isLoadingCustomers ||
                  isLoadingQueryPermissions) && <DrawerLoading />}
                <div className="title-syncx">Filtro avançado</div>
                <div className="flex flex-col md:flex-row gap-3 md:gap-20">
                  <div className="mt-6 min-w-[250px]">
                    <AutoCompleteInput
                      options={listCustomers}
                      label="Cliente"
                      onChange={(customer) => setSelectedCustomer(customer)}
                      value={selectedCustomer?.value}
                      isLoading={isLoadingCustomers}
                    />
                    {errorListCustomers && (
                      <Alert color="failure" className="mt-2">
                        Ocorreu um erro ao buscar clientes
                      </Alert>
                    )}
                  </div>
                  <div>
                    <div className="font-semibold mt-2 text-sm mb-2">
                      Período
                    </div>
                    <div className="flex items-center gap-1">
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                          if (moment(e.target.value).isAfter(moment(endDate))) {
                            setEndDate(e.target.value);
                          }
                        }}
                        className="w-full block py-3 md:py-2 px-2 rounded-md text-xs text-gray-600 bg-gray-100 border-0 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer"
                      />
                      <div className="text-xs">Até</div>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                        }}
                        min={startDate}
                        className="w-full block py-3 md:py-2 px-2 rounded-md text-xs text-gray-600 bg-gray-100 border-0 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer"
                      />
                    </div>
                  </div>
                  <div className="mt-2 text-sm">
                    <div className="font-semibold">Status</div>
                    <ul className="mt-3 flex flex-col md:flex-row gap-2 md:gap-4">
                      <div className="flex items-center gap-2">
                        <Checkbox
                          id="sucesso"
                          checked={selectedStatuses.includes(1)}
                          onChange={() =>
                            handleCheckboxChange(1, setSelectedStatuses)
                          }
                        />
                        <Label htmlFor="sucesso" className="flex">
                          Sucesso
                        </Label>
                      </div>
                      <div className="flex items-center gap-2">
                        <Checkbox
                          id="falha"
                          checked={selectedStatuses.includes(0)} // 0 = Falha
                          onChange={() =>
                            handleCheckboxChange(0, setSelectedStatuses)
                          }
                        />
                        <Label htmlFor="falha" className="flex">
                          Falha
                        </Label>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* {listCategoryQueries?.map((category, idxCat) => (
              <div key={idxCat}>
                {category?.Queries?.length > 0 && (
                  <div className="mt-4 text-sm">
                    <div className="font-semibold">{category.name}</div>
                    <ul className="mt-2 flex flex-col gap-2">
                      {category?.Queries?.map((query, index) => (
                        <div className="flex items-center gap-2" key={index}>
                          <Checkbox
                            id={`query-${query.id}`}
                            checked={selectedQueries.includes(query.id)}
                            onChange={() =>
                              handleCheckboxChange(query.id, setSelectedQueries)
                            }
                          />
                          <Label htmlFor={`query-${query.id}`} className="flex">
                            {query.name}
                          </Label>
                        </div>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))} */}
          </div>
        )}

        <div
          className="flex-1 overflow-x-scroll print-padding print-content"
          ref={reportRef}
        >
          <div className="title-syncx mt-3 mb-4">Resultado da busca</div>
          {startDate && endDate && (
            <div className="italic text-sm mb-2 flex items-center gap-2">
              Informações baseadas no período de{" "}
              <Badge className="w-fit">
                {moment(startDate).format("DD/MM/yyyy")}
              </Badge>{" "}
              até{" "}
              <Badge className="w-fit">
                {" "}
                {moment(endDate).format("DD/MM/yyyy")}
              </Badge>
            </div>
          )}

          <div className="overflow-x-auto">
            <div className="flex gap-3 pb-3" style={{ minWidth: "800px" }}>
              <Card
                className="w-full bg-gray-700 relative"
                style={{ minWidth: "150px" }}
              >
                <div className="text-sm md:text-md lg:text-lg text-white">
                  Valor Total:
                </div>
                <div className="text-2xl text-white font-semibold flex gap-2 items-center">
                  {!isLoadingReportQueries ? (
                    `${formatToReal(totalPriceSum)}`
                  ) : (
                    <div
                      role="status"
                      className="max-w-sm animate-pulse inline"
                    >
                      <div className="h-7 bg-gray-200 rounded-full dark:bg-gray-700 w-40"></div>
                    </div>
                  )}
                </div>
                <MdOutlineAttachMoney className="absolute bottom-0 right-0 text-white text-9xl opacity-10" />
              </Card>
              <Card className="w-full bg-gray-700 relative overflow-hidden">
                <div className="text-sm md:text-md lg:text-lg text-white">
                  Total de consultas:
                </div>
                <div className="text-2xl text-white font-semibold">
                  {!isLoadingReportQueries ? (
                    `${totalCount}`
                  ) : (
                    <div
                      role="status"
                      className="max-w-sm animate-pulse inline"
                    >
                      <div className="h-7 bg-gray-200 rounded-full dark:bg-gray-700 w-40"></div>
                    </div>
                  )}
                </div>
                <BsFillBarChartFill className="absolute bottom-0 right-2 text-white text-9xl opacity-10" />
              </Card>
              {selectedCustomer?.value !== 0 && (
                <>
                  {selectedCustomer?.typePayment === "POS" ? (
                    <Card
                      className="w-full bg-gray-700 relative"
                      style={{ minWidth: "150px" }}
                    >
                      <div className="text-sm md:text-md lg:text-lg text-white">
                        Consumação Mínima (VCM):
                      </div>
                      <div className="text-2xl text-white font-semibold flex gap-2 items-center">
                        {selectedCustomer?.vcm
                          ? formatToReal(selectedCustomer?.vcm)
                          : "-"}
                      </div>
                      <MdOutlineAttachMoney className="absolute bottom-0 right-0 text-white text-9xl opacity-10" />
                    </Card>
                  ) : (
                    <Card
                      className="w-full bg-gray-700 relative"
                      style={{ minWidth: "150px" }}
                    >
                      <div className="text-sm md:text-md lg:text-lg text-white">
                        Saldo Atual:
                      </div>
                      <div className="text-2xl text-white font-semibold flex gap-2 items-center">
                        {formatToReal(selectedCustomer?.credit)}
                      </div>
                      <MdOutlineAttachMoney className="absolute bottom-0 right-0 text-white text-9xl opacity-10" />
                    </Card>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="mb-4 mt-2 flex flex-col md:flex-row  justify-between items-end md:items-center gap-2">
            <div className="flex gap-2 items-center">
              <div className="text-xs font-semibold">Visualizar relatório:</div>
              <ul className="text-sm rounded-md border border-gray-300 flex">
                <li
                  className={`py-2 px-4 rounded-md cursor-pointer ${
                    activeTab === 1
                      ? `bg-primary text-white font-semibold shadow-md`
                      : `bg-white`
                  }`}
                  onClick={() => setActiveTab(1)}
                >
                  Simplificado
                </li>
                <li
                  className={`py-2 px-4 rounded-md cursor-pointer ${
                    activeTab === 0
                      ? `bg-primary text-white font-semibold shadow-md`
                      : `bg-white`
                  }`}
                  onClick={() => setActiveTab(0)}
                >
                  Detalhado
                </li>
              </ul>
            </div>
          </div>
          {activeTab === 0 && (
            <form
              className="flex gap-1 mt-0 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300"
              onSubmit={handleSearchName}
            >
              <input
                type="text"
                placeholder="Busque por parâmetro da consulta..."
                className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
                onChange={(e) => setSearchName(e.target.value)}
                value={searchName}
              />
              <Button
                size="sm"
                className="flex items-center bg-secondary w-20"
                type="submit"
              >
                <IoMdSearch />
              </Button>
            </form>
          )}

          <small
            className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
            style={{ fontSize: 10 }}
          >
            <span>
              Deslize para o lado para visualizar todas as informações
            </span>{" "}
            <FaArrowsLeftRight />
          </small>
          {activeTab === 0 ? (
            <>
              {listReportQueries?.length > 0 || isLoadingReportQueries ? (
                <div className="overflow-x-auto shadow-md rounded-lg mt-0 md:mt-5">
                  <Table striped style={{ fontSize: "13px" }}>
                    <Table.Head>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Data
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Produto/Consulta
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Adicionais
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Valor da consulta
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Parâmetro
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Usuário
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Status
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Ações
                      </Table.HeadCell>
                    </Table.Head>

                    <Table.Body className="divide-y">
                      {!isLoadingReportQueries ? (
                        <>
                          {listReportQueries?.length > 0 && (
                            <>
                              {listReportQueries?.map((query, index) => (
                                <Table.Row
                                  key={index}
                                  className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                >
                                  <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                    {moment(query.createdAt).format(
                                      "DD/MM/yyyy | HH:mm"
                                    )}
                                  </Table.Cell>
                                  <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                    {query.queryName}
                                  </Table.Cell>
                                  <Table.Cell
                                    className="font-medium text-gray-900 dark:text-white text-center py-2 overflow-hidden text-ellipsis whitespace-nowrap max-w-xs text-2xs"
                                    title={query.additionalQueriesNames}
                                  >
                                    {query.additionalQueriesNames}
                                  </Table.Cell>
                                  <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                    <div className="flex justify-center items-center gap-1">
                                      {formatToReal(query?.price)}
                                      {userPermission === "POWER_USER" && (
                                        <MdEdit
                                          className="text-green-600 cursor-pointer"
                                          size={16}
                                          onClick={() => {
                                            setQueryToEdit(query);
                                            setNewPrice(query?.price || "");
                                            setEditPriceModalOpen(true);
                                          }}
                                        />
                                      )}
                                    </div>
                                  </Table.Cell>
                                  <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                    {query.parameter}
                                  </Table.Cell>
                                  <Table.Cell className="text-center py-2">
                                    {query.userName}
                                  </Table.Cell>
                                  <Table.Cell className="text-center py-2">
                                    {query.isSuccess ? (
                                      <Badge
                                        color="success"
                                        className="w-fit mx-auto text-xs"
                                      >
                                        Sucesso
                                      </Badge>
                                    ) : (
                                      <Badge
                                        color="failure"
                                        className="w-fit mx-auto text-xs"
                                      >
                                        Falha
                                      </Badge>
                                    )}
                                  </Table.Cell>
                                  <Table.Cell className="text-center py-2">
                                    {!query.isModular && (
                                      <div className="flex gap-2 justify-center">
                                        {query?.isSuccess && (
                                          <div>
                                            <Tooltip
                                              id="tooltip-save"
                                              content={`Visualizar consulta`}
                                            />
                                            <MdOutlinePageview
                                              data-tooltip-id="tooltip-save"
                                              className="cursor-pointer"
                                              fontSize={26}
                                              onClick={() => {
                                                setSelectedQueryReview(query);
                                                setDataQuery(query.data);
                                                setOpenModal(true);
                                              }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </Table.Cell>
                                </Table.Row>
                              ))}
                            </>
                          )}
                        </>
                      ) : (
                        <TableLoading cols={7} />
                      )}
                    </Table.Body>
                  </Table>
                </div>
              ) : (
                <EmptyTable icon="search_off">
                  Nenhum registro encontrado com esses filtros
                </EmptyTable>
              )}
            </>
          ) : (
            <>
              {listReportSimplifiedQueries?.length > 0 ||
              isLoadingReportSimplifiedQueries ? (
                <div className="overflow-x-auto shadow-md rounded-lg mt-0 md:mt-5">
                  <Table striped style={{ fontSize: "13px" }}>
                    <Table.Head>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Produto/Consulta
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Qtd. Total
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Valor Total
                      </Table.HeadCell>
                    </Table.Head>

                    <Table.Body className="divide-y">
                      {!isLoadingReportSimplifiedQueries ? (
                        <>
                          {listReportSimplifiedQueries?.length > 0 && (
                            <>
                              {listReportSimplifiedQueries.map(
                                (query, index) => (
                                  <Table.Row
                                    key={index}
                                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                  >
                                    <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                      {query.queryName}
                                    </Table.Cell>
                                    <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                      {query.count}
                                    </Table.Cell>
                                    <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                      {formatToReal(query?.totalPrice || 0)}
                                    </Table.Cell>
                                  </Table.Row>
                                )
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {Array.from({ length: 12 }).map((_, index) => (
                            <Table.Row
                              key={index}
                              className="bg-white dark:border-gray-700 dark:bg-gray-800"
                            >
                              <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                <div
                                  role="status"
                                  className="max-w-sm animate-pulse inline"
                                >
                                  <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-40 mx-auto"></div>
                                </div>
                              </Table.Cell>
                              <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                <div
                                  role="status"
                                  className="max-w-sm animate-pulse inline"
                                >
                                  <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-40 mx-auto"></div>
                                </div>
                              </Table.Cell>
                              <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                <div
                                  role="status"
                                  className="max-w-sm animate-pulse inline"
                                >
                                  <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-40 mx-auto"></div>
                                </div>
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </>
                      )}
                    </Table.Body>
                  </Table>
                </div>
              ) : (
                <EmptyTable icon="search_off">
                  Nenhum registro encontrado com esses filtros
                </EmptyTable>
              )}
            </>
          )}

          {totalPages > 1 && (
            <div className="flex overflow-x-auto justify-center mt-3">
              <Pagination
                layout="pagination"
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                previousLabel=""
                nextLabel=""
                showIcons
              />
            </div>
          )}
        </div>
        <Modal
          show={openModalViewDetails}
          size="4xl"
          onClose={() => setOpenModalViewDetails(false)}
          popup
          className="relative"
        >
          <Modal.Header />
          <Modal.Body>
            <Tabs
              aria-label="Tabs with underline"
              variant="underline"
              onActiveTabChange={(tab) => setActiveTabModal(tab)}
            >
              <Tabs.Item active title="Informações">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="flex items-center gap-2">
                    <div className="font-semibold">Consulta:</div>
                    <div>{selectedQuery?.queryName}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="font-semibold">Data | Hora:</div>
                    <div>
                      {moment(selectedQuery?.createdAt).format(
                        "DD/MM/yyyy | HH:mm"
                      )}
                      h
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="font-semibold">Parâmetro da Consulta:</div>
                    <div>
                      {queryDetails?.QueryCustomized?.parameterType || "-"}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="font-semibold">Parâmetro:</div>
                    <div>{selectedQuery?.parameter}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="font-semibold">
                      Mostrar quadro de avisos:
                    </div>
                    <div>
                      {selectedQuery?.QueryCustomized?.showAlertsBoard
                        ? "Sim"
                        : "Não"}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="font-semibold">Usuário:</div>
                    <div>{selectedQuery?.userName}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="font-semibold">Preço:</div>
                    <div>{selectedQuery?.price || "R$0,00"}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="font-semibold">Status:</div>
                    <div>
                      {selectedQuery?.isSuccess ? (
                        <Badge className="inline-block" color="success">
                          Sucesso
                        </Badge>
                      ) : (
                        <Badge className="inline-block" color="failure">
                          Falha
                        </Badge>
                      )}
                    </div>
                  </div>
                </div>
              </Tabs.Item>
              <Tabs.Item title="Status">
                <div className="overflow-y-auto" style={{ maxHeight: "400px" }}>
                  <Accordion collapseAll>
                    {queryDetails?.userQuery?.data ? (
                      Object.entries(queryDetails?.userQuery?.data)
                        ?.filter(([key]) => key !== "statusRetorno")
                        .map(([key, customQuery], index) => (
                          <Accordion.Panel key={index}>
                            <Accordion.Title className="text-xs">
                              <div className="flex gap-2 items-center">
                                <div>{key}</div>
                                {key !== "resumoRetorno" && (
                                  <>
                                    {customQuery?.statusRetorno == 1 ? (
                                      <Badge
                                        className="inline-block text-2xs"
                                        color="success"
                                      >
                                        Sucesso{" "}
                                        {customQuery?.provedorReserva &&
                                          "parcial"}
                                      </Badge>
                                    ) : (
                                      <Badge
                                        className="inline-block text-2xs"
                                        color="failure"
                                      >
                                        Falha
                                      </Badge>
                                    )}{" "}
                                  </>
                                )}
                              </div>
                            </Accordion.Title>

                            <Accordion.Content>
                              {customQuery?.error ? (
                                <div className="text-sm">
                                  <div className="font-semibold">
                                    Log de erro:
                                  </div>
                                  <div className="text-red-500 bg-gray-800 p-2 mt-1">
                                    {Array.isArray(customQuery?.error) &&
                                      customQuery?.error?.map(
                                        (error, index) => (
                                          <div
                                            className="mb-4 border-b border-red-500 pb-2"
                                            key={index}
                                          >
                                            <div>
                                              Provedor: {error?.provider}
                                            </div>
                                            <div className="font-semibold">
                                              {error?.message}
                                            </div>
                                          </div>
                                        )
                                      )}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-sm">
                                  <div className="font-semibold">
                                    Dados retornados
                                  </div>
                                  <CodeBlock
                                    theme={dracula}
                                    text={JSON.stringify(customQuery, null, 2)}
                                  />
                                </div>
                              )}
                            </Accordion.Content>
                          </Accordion.Panel>
                        ))
                    ) : (
                      <p className="text-xs text-center text-gray-400 py-4">
                        Nenhum log encontrado!
                      </p>
                    )}
                  </Accordion>
                </div>
              </Tabs.Item>
            </Tabs>
          </Modal.Body>
          {isLoadingQueryDetails && <DrawerLoading />}
        </Modal>

        <Modal show={openModal} onClose={() => setOpenModal(false)} size="4xl">
          <ModalHeader>Visualizar consulta</ModalHeader>
          <ModalBody className="bg-gray-100">
            <div style={{ zoom: "0.7" }} className="" ref={printRef}>
              <SelectedQueryReview
                dataFromLocalStorage={dataQuery}
                query={selectedQueryReview}
              />
            </div>
          </ModalBody>
          <ModalFooter className="flex justify-center">
            <Button onClick={() => reactToPrintFnQuery()}>Imprimir</Button>
            <Button color="gray" onClick={() => setOpenModal(false)}>
              Fechar
            </Button>
          </ModalFooter>
        </Modal>

        <ModalEditPrice
          isOpen={editPriceModalOpen}
          initialPrice={newPrice}
          onClose={() => {
            setEditPriceModalOpen(false);
            setQueryToEdit(null);
          }}
          onSave={async (parsedPrice) => {
            try {
              await axios.put(
                `${ADMIN.UPDATE_QUERY_PRICE}/${queryToEdit?.id}`,
                {
                  price: parsedPrice,
                }
              );
              queryClient.invalidateQueries("listReportQueries");
              setEditPriceModalOpen(false);
              setQueryToEdit(null);
            } catch (error) {
              alert("Erro ao atualizar preço");
            }
          }}
        />
      </div>
    </div>
  );
};

export default AdminHistoryTable;
